<div *ngIf="validUsers.includes(user.email)">
  <button
    class="fp-btn fp-download-btn fr-btn-type-html fp-save-button"
    (click)="save()"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
        fill="white"
      />
    </svg>
    <span>Save</span>
  </button>
  <!-- <ejs-richtexteditor
    id="welcome-editor"
    [(value)]="content"
    [insertImageSettings]="jobsService.insertImageSettings"
    (imageUploading)="jobsService.addHeaders($event)"
    (imageUploadSuccess)="jobsService.onUploadSuccess($event)"
    [saveInterval]="jobsService.saveInterval"
    [toolbarSettings]="gettingStartedService.welcomeToolbarSettings"
    [autoSaveOnIdle]="false"
  >
  </ejs-richtexteditor> -->
  <p-editor [(ngModel)]="content" [style]="{ height: '320px' }">
    <p-header>                                          
      <span class="ql-formats">
        <select class="ql-font ql-picker">
          <option selected>Sans Serif</option>
          <option value="serif">Serif</option>
          <option value="monospace">Monospace</option>
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold" aria-label="Bold"></button>
        <button class="ql-italic" aria-label="Italic"></button>
        <button class="ql-underline" aria-label="Underline"></button>
        <button class="ql-strike" aria-label="Strike"></button>
      </span>
      <span class="ql-formats">
        <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
        </select>
        <span class="ql-format-separator"></span>
        <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered" type="button"></button>
        <button class="ql-list" value="bullet" type="button"></button>
      </span>
      <span class="ql-formats">
        <button aria-label="Link" class="ql-link"></button>
        <button aria-label="Image" class="ql-image"></button>
      </span>
    </p-header> 
  </p-editor>
</div>

<div
  id="welcome-user"
  *ngIf="!validUsers.includes(user.email)"
  [innerHTML]="_sanitizer.bypassSecurityTrustHtml(content)"
></div>
